<template>
  <div class="strategy-call-to-action-2-section">
    <call-to-action>
      <template v-slot:info-box>
        <div class="title paragraph-1-large">{{ fields.field_one.value.testimonials[0].text }}</div>
        <div class="username caps-medium">{{ fields.field_one.value.testimonials[0].text2 }}</div>
      </template>
      <template v-slot:image-box>
        <img v-scroll-animate :src="fields.field_one.value.testimonials[0].image" alt="">
      </template>
    </call-to-action>
  </div>
</template>

<script>
import CallToAction from "/seu-frontend/components/section-fields/CallToAction";

export default {
  name: "StrategyCallToAction2Section",
  components: {CallToAction},
  props: {
    fields: {
      type: Object
    }
  },
}
</script>

<style lang="scss">
@import "StrategyCallToAction2Section.scss";
</style>
